module.exports = __webpack_public_path__ + "static/media/save-money.e1d8ae72.svg";